import { Avatar, Button, Card, CardContent, CardHeader, Chip, Divider, FormControlLabel, Grid, IconButton, InputAdornment, Paper, Stack, Switch, TextField, Tooltip, Typography } from "@mui/material";
import SelectAmountCard from "./SelectAmountCard";
import { useTranslation } from "react-i18next";
import { useTransactionWalletMutation } from "src/_api/mapitShipApi";
import { ConfirmDialog } from "src/_modules/common";
import { useState } from "react";
import { useChargeFromCodWalletMutation, useGetCurrentInvoiceQuery, useGetCouponsCardQuery, useApplyCouponCodeMutation } from "src/_api/mapitShipInvoice";
import { useSelector } from "react-redux";
import RedeemRoundedIcon from '@mui/icons-material/RedeemRounded';
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ContentCopyRoundedIcon from "@mui/icons-material/ContentCopyRounded";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import copy from "copy-to-clipboard";
import { alpha } from "@mui/material/styles";
import { LoadingButton } from "@mui/lab";
import { NATIONAL_DAY_CASHBACK_CAP, NATIONAL_DAY_CASHBACK_RATE, NATIONAL_DAY_COLORS, NATIONAL_DAY_COUPON } from "./nationalDay";
export default function ChargeAmountCards() {
    const { t } = useTranslation()
    const profile = useSelector((state) => state.entities.profile.profile);
    // console.log("profile" , profile);
    // console.log("profile oddo id" , profile?.merchant?.odooCustomerId);

    const chargeValues = [100, 500, 1000]
    const [code, setCode] = useState("");
    const [vat, setVat] = useState(0);
    //======= Charge Wallet =========

    const [chargeWallet, { isLoading, error, reset }] = useTransactionWalletMutation()
    const [amount, setAmount] = useState(0)

    //======= Coupon input visibility (admin-controlled setting) =======
    const { data: couponsCard } =
        useGetCouponsCardQuery({
            fields: "showCouponInput",
        });

    const onConfirm = async (amount) => {
        try {
            ChargeFromCodWalletReset()
            setAmount(amount)
            setOpenConfirmDialog(true)
        } catch (error) {
            console.log(error)
        }
    }

    //======= COD wallet =======
    const { data: invoice } = useGetCurrentInvoiceQuery()

    const [codWallet, setCodWallet] = useState(false)
    const [chargeFromCodWallet, {
        isLoading: ChargeFromCodWalletLoading,
        error: ChargeFromCodWalletError,
        isSuccess: ChargeFromCodWalletSuccess,
        reset: ChargeFromCodWalletReset
    }] = useChargeFromCodWalletMutation()



    //======= Confirm Dialog Handlers =========
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false)

    const closeConfirmDialogHandler = () => {
        setOpenConfirmDialog(false)
        setAmount(0)
        reset()
        ChargeFromCodWalletReset()
        setCouponData(null);
        setCode("");
        setAppliedCode("");
        ApplyCouponReset();
    }

    const confirmChargeHandler = async () => {
        try {
            let totaLCharge = Number((amount + (amount * 0.15)).toFixed(2))
            let vat = amount * 0.15

            if (codWallet) {
                await chargeFromCodWallet({ amount: totaLCharge, vat, code: code.trim() }).unwrap()
                setTimeout(() => {
                    closeConfirmDialogHandler()
                }, 2000);
            } else {
                let response = await chargeWallet({ amount: totaLCharge, vat, lastPageUrl: window.location.pathname, code: code.trim() }).unwrap()
                if (!!response?.url) {
                    window.open(response?.url, "_self")
                }
                closeConfirmDialogHandler()
            }
        } catch (error) {
            console.log(error)
        }
    }

    const [couponData, setCouponData] = useState(null);
    const [appliedCode, setAppliedCode] = useState("");

    //======= National Day coupon copy =======
    const [couponCopied, setCouponCopied] = useState(false);
    const copyNationalDayCoupon = () => {
        copy(NATIONAL_DAY_COUPON);
        setCouponCopied(true);
        setTimeout(() => setCouponCopied(false), 2000);
    };


    const couponExpiredByUsage =
        couponData &&
        couponData.usageLimitPerCustomer > 0 &&
        couponData.userCouponCount >= couponData.usageLimitPerCustomer;

    const couponTone = couponExpiredByUsage ? "warning" : "success";

    // Whole riyals stay whole — "25 riyal" reads better than "25.00 riyal".
    const formatCashback = (value) => {
        const number = Number(value) || 0;
        return Number.isInteger(number) ? String(number) : number.toFixed(2);
    };

    // How the cashback is calculated — only meaningful for PERCENTAGE coupons, where
    // the cap explains why the amount can be lower than rate x charge. A FIXED coupon
    // needs no note: the cashback sentence already states the whole amount.
    const couponTermsNote = (() => {
        const rate = Number(couponData?.cashback) || 0;
        const limit = Number(couponData?.cashbackLimit) || 0;
        const limitText = t("MoneyAmount", { amount: formatCashback(limit) });

        if (!couponData) return "";
        if (couponData.discountType === "PERCENTAGE" && rate > 0) {
            return limit > 0
                ? t("coupon.termsPercentageCapped", { rate: formatCashback(rate), limit: limitText })
                : t("coupon.termsPercentage", { rate: formatCashback(rate) });
        }
        // Type not reported by the endpoint — a cap is still worth surfacing on its own.
        if (!couponData.discountType && limit > 0) {
            return t("coupon.termsCapOnly", { limit: limitText });
        }
        return "";
    })();

    // One sentence about the customer's own usage of this coupon, or "" when the
    // coupon has no per-customer cap (usageLimitPerCustomer 0 / missing).
    const couponUsageNote = (() => {
        const limit = Number(couponData?.usageLimitPerCustomer) || 0;
        const used = Number(couponData?.userCouponCount) || 0;

        if (!couponData || limit <= 0) return "";
        if (used >= limit) return t("coupon.maxUsageNote", { count: used });
        if (used === 0) {
            return limit === 1
                ? t("coupon.singleUse")
                : t("coupon.firstUse", { count: limit - 1 });
        }
        return t("coupon.usedBefore", { count: used, limit });
    })();

    //======= Apply Coupon =======

    const [applyCoupon, {
        isLoading: ApplyCouponLoading,
        error: ApplyCouponError,
        reset: ApplyCouponReset
    }] = useApplyCouponCodeMutation()


    const applyCouponHandler = async () => {
        try {

            let totaLCharge = Number((amount + (amount * 0.15)).toFixed(2))
            let vat = amount * 0.15

            const trimmedCode = code.trim()

            const res = await applyCoupon({ code: trimmedCode, amount: totaLCharge, vat }).unwrap();
            setCouponData(res);
            setAppliedCode(trimmedCode);
        } catch (error) {
            console.log("error:", error);
            setCouponData(null);
            setAppliedCode("");
        }
    };

    // Typing again invalidates the previous attempt so a stale error never sticks
    // to a code the user has already changed.
    const codeChangeHandler = ({ target: { value } }) => {
        setCode(value);
        if (ApplyCouponError) ApplyCouponReset();
    };

    // The applied code is what gets sent with the charge, so it stays locked until
    // it is explicitly removed — editing it in place would desync code from couponData.
    const removeCouponHandler = () => {
        setCode("");
        setAppliedCode("");
        setCouponData(null);
        ApplyCouponReset();
    };
    return (
        <Card id="charge-amount-cards">
            <CardHeader
                title={t("Charge Amount")}
                subheader={!!error && <Typography color="error">{error}</Typography>}
            />
            <Divider />
            <ConfirmDialog
                open={openConfirmDialog}
                onClose={closeConfirmDialogHandler}
                title={t("Charge Wallet")}
                confirmFn={confirmChargeHandler}
                loading={isLoading || ChargeFromCodWalletLoading}
                error={error || ChargeFromCodWalletError}
                isSuccess={ChargeFromCodWalletSuccess}
                content={t("confirmChargeWallet", { amount: (amount + (amount * 0.15)).toFixed(2), currency: t("Currency") })}
                odooId={profile?.merchant?.odooCustomerId}
            >
                <Grid container spacing={2} sx={{ mt: 1 }}>
                    <Grid item xs={6}>
                        <Typography color="text.lighter">
                            {t("Charge Amount")}
                        </Typography>
                        <Typography variant='h5' color="primary">
                            {amount} {t("Currency")}
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography color="text.lighter">
                            {t("Tax (15%)")}
                        </Typography>
                        <Typography variant='h5' color="primary">
                            {(amount * 0.15).toFixed(2)} {t("Currency")}
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography color="text.lighter">
                            {t("Total")}
                        </Typography>
                        <Typography variant='h5' color="primary">
                            {(amount + (amount * 0.15)).toFixed(2)} {t("Currency")}
                        </Typography>
                    </Grid>
                </Grid>

                <Paper
                    variant="outlined"
                    sx={{
                        mt: 2,
                        p: 1.5,
                        borderRadius: 2,
                        borderColor: alpha(NATIONAL_DAY_COLORS.green, 0.4),
                        bgcolor: alpha(NATIONAL_DAY_COLORS.green, 0.07)
                    }}
                >
                    <Stack direction="row" spacing={1.25} alignItems="flex-start">
                        <Avatar
                            sx={{
                                width: 32,
                                height: 32,
                                bgcolor: alpha(NATIONAL_DAY_COLORS.green, 0.16),
                                color: NATIONAL_DAY_COLORS.green
                            }}
                        >
                            <RedeemRoundedIcon sx={{ fontSize: 18 }} />
                        </Avatar>
                        <Stack spacing={0.75} sx={{ flex: 1 }}>
                            <Stack
                                direction="row"
                                spacing={1}
                                alignItems="center"
                                justifyContent="space-between"
                                useFlexGap
                                flexWrap="wrap"
                            >
                                <Typography
                                    variant="subtitle2"
                                    sx={{ fontWeight: 800, color: NATIONAL_DAY_COLORS.deep }}
                                >
                                    {t("nationalDayCashbackDialog.title")}
                                </Typography>
                                <Stack direction="row" alignItems="center" spacing={0.5}>
                                    <Chip
                                        size="small"
                                        label={NATIONAL_DAY_COUPON}
                                        sx={{
                                            fontWeight: 800,
                                            letterSpacing: 1.5,
                                            direction: "ltr",
                                            color: "#fff",
                                            bgcolor: NATIONAL_DAY_COLORS.green
                                        }}
                                    />
                                    <Tooltip title={t(couponCopied ? "Copied" : "Copy")} placement="top">
                                        <IconButton
                                            size="small"
                                            onClick={copyNationalDayCoupon}
                                            aria-label={t("Copy")}
                                            sx={{
                                                color: couponCopied ? NATIONAL_DAY_COLORS.green : NATIONAL_DAY_COLORS.deep,
                                                bgcolor: alpha(NATIONAL_DAY_COLORS.green, 0.1),
                                                "&:hover": { bgcolor: alpha(NATIONAL_DAY_COLORS.green, 0.2) }
                                            }}
                                        >
                                            {couponCopied
                                                ? <CheckRoundedIcon sx={{ fontSize: 16 }} />
                                                : <ContentCopyRoundedIcon sx={{ fontSize: 16 }} />}
                                        </IconButton>
                                    </Tooltip>
                                </Stack>
                            </Stack>

                            <Typography variant="body2" color="text.secondary">
                                {t("nationalDayCashbackDialog.rateNote", {
                                    rate: NATIONAL_DAY_CASHBACK_RATE,
                                    code: NATIONAL_DAY_COUPON
                                })}
                            </Typography>

                            <Typography variant="body2" color="text.secondary">
                                {t("nationalDayCashbackDialog.capNote", {
                                    limit: t("MoneyAmount", { amount: NATIONAL_DAY_CASHBACK_CAP })
                                })}
                            </Typography>
                        </Stack>
                    </Stack>
                </Paper>

                {(profile?.merchant?.deliveryMethod?.includes("MAPIT_SHIP") || profile?.merchant?.onlinePayment) &&
                    <>
                        <Divider sx={{ my: 1 }} />
                        <Stack spacing={1}>
                            <Stack direction="row" alignItems="center" spacing={0.5}>
                                <Typography variant="subtitle" fontWeigh="bold" color="text.lighter">
                                    {t("Available balance")} :
                                </Typography>
                                <Typography variant="subtitle" fontWeigh="bold">
                                    {t("MoneyAmount", { amount: invoice?.dueAmount?.toFixed(2) })}
                                </Typography>
                            </Stack>
                            <Stack direction="row" alignItems="center" spacing={2}>
                                <Tooltip placement="top" title={invoice?.dueAmount === 0 ? t("The available balance must be equal or more than the charge amount") : ""}>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={codWallet}
                                                onChange={({ target: { checked } }) => setCodWallet(checked)}
                                                disabled={!invoice || invoice?.dueAmount === 0}
                                            />
                                        }
                                        label={t("COD Wallet")}
                                    />
                                </Tooltip>
                                <Typography variant="caption" color="secondary">
                                    {t("Charge amount will be deducted from COD wallet")}
                                </Typography>

                            </Stack>
                            <Divider sx={{ my: 1 }} />
                            {couponsCard?.showCouponInput && (
                                <Paper
                                    variant="outlined"
                                    sx={{
                                        p: 2,
                                        borderRadius: 2,
                                        borderStyle: appliedCode ? "solid" : "dashed",
                                        borderColor: appliedCode
                                            ? (theme) => alpha(theme.palette[couponTone].main, 0.45)
                                            : "divider",
                                        bgcolor: appliedCode
                                            ? (theme) => alpha(theme.palette[couponTone].main, 0.06)
                                            : "transparent",
                                        transition: "background-color .2s ease, border-color .2s ease"
                                    }}
                                >
                                    <Stack spacing={1.5}>
                                        <Stack direction="row" alignItems="center" spacing={1}>
                                            <LocalOfferOutlinedIcon
                                                fontSize="small"
                                                color={appliedCode ? couponTone : "primary"}
                                            />
                                            <Typography variant="subtitle2" fontWeight={700}>
                                                {t("Cashback Coupon")}
                                            </Typography>
                                        </Stack>

                                        {!appliedCode ? (
                                            <Stack spacing={0.75}>
                                                <Stack direction="row" spacing={1} alignItems="flex-start">
                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        value={code}
                                                        onChange={codeChangeHandler}
                                                        onKeyDown={(e) => {
                                                            if (e.key === "Enter" && !!code.trim() && !ApplyCouponLoading) {
                                                                e.preventDefault()
                                                                applyCouponHandler()
                                                            }
                                                        }}
                                                        placeholder={t("Enter coupon code")}
                                                        error={!!ApplyCouponError}
                                                        helperText={ApplyCouponError || ""}
                                                        InputProps={{
                                                            startAdornment: (
                                                                <InputAdornment position="start">
                                                                    <LocalOfferOutlinedIcon
                                                                        fontSize="small"
                                                                        sx={{ color: "text.disabled" }}
                                                                    />
                                                                </InputAdornment>
                                                            )
                                                        }}
                                                        sx={{
                                                            "& .MuiOutlinedInput-root": {
                                                                borderRadius: 1.5,
                                                                bgcolor: "background.paper"
                                                            },
                                                            "& .MuiFormHelperText-root": { mx: 0.5 }
                                                        }}
                                                    />
                                                    <LoadingButton
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={applyCouponHandler}
                                                        disabled={!code.trim() || ApplyCouponLoading}
                                                        loading={ApplyCouponLoading}
                                                        sx={{
                                                            minWidth: 104,
                                                            height: 40,
                                                            flexShrink: 0,
                                                            borderRadius: 1.5,
                                                            boxShadow: "none"
                                                        }}
                                                    >
                                                        {t("Apply")}
                                                    </LoadingButton>
                                                </Stack>

                                                {!ApplyCouponError && (
                                                    <Typography variant="caption" color="text.secondary">
                                                        {t("coupon.hint")}
                                                    </Typography>
                                                )}
                                            </Stack>
                                        ) : (
                                            <Stack spacing={1.25}>
                                                <Stack
                                                    direction="row"
                                                    alignItems="center"
                                                    justifyContent="space-between"
                                                    spacing={1}
                                                    useFlexGap
                                                    flexWrap="wrap"
                                                >
                                                    <Chip
                                                        size="small"
                                                        color={couponTone}
                                                        variant="outlined"
                                                        icon={
                                                            couponExpiredByUsage
                                                                ? <ErrorOutlineRoundedIcon />
                                                                : <CheckCircleRoundedIcon />
                                                        }
                                                        label={appliedCode}
                                                        sx={{
                                                            fontWeight: 800,
                                                            letterSpacing: 1,
                                                            direction: "ltr",
                                                            bgcolor: "background.paper"
                                                        }}
                                                    />
                                                    <Button
                                                        size="small"
                                                        color="inherit"
                                                        startIcon={<CloseRoundedIcon fontSize="small" />}
                                                        onClick={removeCouponHandler}
                                                        sx={{ color: "text.secondary", minWidth: 0 }}
                                                    >
                                                        {t("coupon.remove")}
                                                    </Button>
                                                </Stack>

                                                <Divider sx={{ borderStyle: "dashed" }} />

                                                <Stack spacing={0.75}>
                                                    {!couponExpiredByUsage && (
                                                        <Stack direction="row" spacing={1} alignItems="flex-start">
                                                            <RedeemRoundedIcon
                                                                fontSize="small"
                                                                sx={{ color: "success.main", mt: "1px", flexShrink: 0 }}
                                                            />
                                                            <Stack spacing={0.25}>
                                                                <Typography
                                                                    variant="body2"
                                                                    fontWeight={700}
                                                                    color="success.main"
                                                                >
                                                                    {t("coupon.cashbackNote", {
                                                                        amount: t("MoneyAmount", {
                                                                            amount: formatCashback(couponData?.cashbackAmount)
                                                                        })
                                                                    })}
                                                                </Typography>

                                                                {!!couponTermsNote && (
                                                                    <Typography
                                                                        variant="caption"
                                                                        color="text.secondary"
                                                                    >
                                                                        {couponTermsNote}
                                                                    </Typography>
                                                                )}
                                                            </Stack>
                                                        </Stack>
                                                    )}

                                                    {!!couponUsageNote && (
                                                        <Stack direction="row" spacing={1} alignItems="flex-start">
                                                            {couponExpiredByUsage
                                                                ? <ErrorOutlineRoundedIcon
                                                                    fontSize="small"
                                                                    sx={{ color: "warning.main", mt: "1px", flexShrink: 0 }}
                                                                />
                                                                : <InfoOutlinedIcon
                                                                    fontSize="small"
                                                                    sx={{ color: "text.disabled", mt: "1px", flexShrink: 0 }}
                                                                />}
                                                            <Typography
                                                                variant="body2"
                                                                color={couponExpiredByUsage ? "warning.main" : "text.secondary"}
                                                                fontWeight={couponExpiredByUsage ? 600 : 400}
                                                            >
                                                                {couponUsageNote}
                                                            </Typography>
                                                        </Stack>
                                                    )}
                                                </Stack>
                                            </Stack>
                                        )}
                                    </Stack>
                                </Paper>
                            )}
                        </Stack>
                    </>
                }
            </ConfirmDialog>
            <CardContent>
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} sm={6} md={4} lg={3} key={"CUSTOM"}>
                        <SelectAmountCard custom={true} onConfirm={onConfirm} loaidng={isLoading} />
                    </Grid>
                    {
                        chargeValues.map((value, index) => (
                            <Grid item xs={12} sm={6} md={4} lg={3} key={value}>
                                <SelectAmountCard key={value} value={value} onConfirm={onConfirm} loaidng={isLoading} />
                            </Grid>
                        ))
                    }
                </Grid>
            </CardContent>
        </Card>
    )
}

// import { Card, CardContent, CardHeader, Divider } from "@mui/material";
// import { useTranslation } from "react-i18next";
// import ChargeWalletWithAmount from "./ChargeWalletWithAmount";

// export default function ChargeAmountCards() {
//     const { t } = useTranslation()

//     return (
//         <Card id="charge-amount-cards">
//             <CardHeader
//                 title={t("Charge Amount")}
//             />
//             <Divider />
//             <CardContent>
//                 <ChargeWalletWithAmount />
//             </CardContent>
//         </Card>
//     )
// }
